/**
 * Mutations for updating the state via actions.
 * Names should reference from mutation types
 */

import * as types from './mutation-types';

export const mutations = {
  [types.SET_FILTER_LIMIT] (state, limit) {
    state.props.size = limit
  },
  [types.SET_DOC_TYPE] (state, type) {
    state.props.docType = type
  },
  [types.SET_DOCUMENTS] (state, options) {
    state.documents[options.docType] = options.documents
    }

};
